<template>
  <ul class="selected-list" v-show="items && items.length > 0">
    <li class="selected-list__item" v-for="item in items">
      <span class="selected-list__item-inner">
        {{item.label}}
        <button class="button button--close" aria-label="Slett" v-on:click="deleteItem(item.id)"></button>
      </span>
    </li>
  </ul>
</template>

<script type="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

interface SelectedItem {
  id: string,
  label: string
}

@Component
export default class FiltersSelected extends Vue {
  @Prop({default: () => [], type: Array}) items: Array<SelectedItem>;
  @Prop({default: () => {}, type: Object}) value: Record<string, string|number|Array<string|number>>;

  private deleteItem(id: string) {
    this.value[id] = null;

    if(id == 's'){
      document.getElementById('global-search').value = '';
    }

    this.$emit('input', this.value);
  }
}
</script>